// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"5376cc02","292":"11080840","347":"f6248075","688":"fb4e1cc3","749":"50618465","797":"84ea61b0","846":"ad8ed24f","893":"e1f75eef","921":"0b888415","986":"406ba2ec"}[chunkId] + ".chunk.css";
};